import React from 'react'
import styled from 'styled-components'
import NoQuestionSubmit from './no-question-submit'
import LazyLoad from 'react-lazyload'

const NoQuestion = () => {
  return (
    <BannerBox>
      <div className="container">
        <div className="left">
          <LazyLoad>
            <img className="banner-product" src={`/images/faq/m-faq-banner2.png`} alt="banner-product" />
          </LazyLoad>
        </div>
        <NoQuestionSubmit />
      </div>
    </BannerBox>
  )
}

export default NoQuestion

const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    margin-top: 62px;
    background-image: url('/images/faq/m-faq-bg2.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .container {
      position: relative;
      height: 600px;
      width: 100%;
      margin: 0 auto;
      padding: 0 32px;
      img {
        width: 100%;
      }
      .left {
        .banner-product {
          position: absolute;
          bottom: 0;
          left: 32px;
          width: 223px;
          height: 268px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1440px;
    margin: 100px auto 0;
    background-image: url('/images/faq/faq-banner2.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .container {
      height: 480px;
      width: 100%;
      max-width: 1440px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 0 156px;
      img {
        width: 100%;
      }
      .left {
        position: relative;
        .banner-product {
          position: absolute;
          bottom: 0;
          width: 397px;
          height: 464px;
        }
      }
    }
  }
`
